/*
 * @Author: Merlin
 * @Date: 2024-05-13 13:23:04
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-18 14:43:28
 * @Description: 
 */
import useSettingsStore from '@/stores/settings/index';
import { useProfileSocket } from '@/socket/profile/index';
import Cookies from 'js-cookie';
import { socket } from '@/utils/webSocket';

// 默认语言
const DEFAULT_LOCALE = 'en';

// 支持的语言列表
const SUPPORTED_LOCALES = [DEFAULT_LOCALE, 'cn'];


// ↓ 做记录，将用户选择的语言记录到服务器 + 浏览器 
export async function toRecordNewLanguage(newVal:string){
    if (!import.meta.client) return false;
    newVal = newVal.toLowerCase();
    // 验证语言是否支持
    if (!SUPPORTED_LOCALES.includes(newVal)) {
        console.error(`不会记录不支持的语言: ${newVal}`);
        return false;
    }
    try {
        // ↓ 保存到本地存储，共3项 
        const settingStore = useSettingsStore();
        settingStore.UILang = newVal;
        Cookies.set('locale', newVal);
        Cookies.set('i18n_redirected', newVal);

        // 如果在线，同步到服务器
        if (navigator.onLine && socket.connected) {
            const oUser = await getUserInfo().catch(err=>{
                return {hasLogged: false};
            });
            if (oUser.hasLogged){
                const { EMIT_USER_LANG } = useProfileSocket();
                const {promise, resolve} = createPromise();
                EMIT_USER_LANG({ lang: newVal }, resolve);
                await promise;
                console.log('语言设置已同步到服务器:', newVal);
            }
        } else {
            console.log('离线模式: 语言设置已保存到本地:', newVal);
        }
        return true;
    } catch (error) {
        console.error('记录语言失败:', error);
        return false;
    }
}

// ↓ 查看浏览器界面语言
function getLangByBrowser(){
    if (!import.meta.client) return DEFAULT_LOCALE;

    try {
        const language = window.navigator.language.toLowerCase();
        if (language.startsWith('zh')) return 'cn';
        return 'en';
    } catch (error) {
        console.error('获取浏览器语言失败:', error);
        return DEFAULT_LOCALE;
    }
}

// ↓ 推断应设为哪种界面语言 
export function inferNewLang(
    sUserLang='', // 若非空，则此值是查到的"后端记录的" 用户的界面语言
){
    if (!import.meta.client) return DEFAULT_LOCALE;

    // 检查用户设置（用户明确指定的界面语言，权重最高）
    if (sUserLang && SUPPORTED_LOCALES.includes(sUserLang)) {
        return sUserLang;
    }

    try {
        // 提取 localstorage 中的记录 
        const storeLang = useSettingsStore().UILang;
        if (storeLang && SUPPORTED_LOCALES.includes(storeLang)) {
            return storeLang;
        }
        
        // 提取 cookie 中的记录
        const cookieLang = Cookies.get('locale');
        if (cookieLang && SUPPORTED_LOCALES.includes(cookieLang)) {
            return cookieLang;
        }

        // 使用浏览器语言
        return getLangByBrowser();
    } catch (error) {
        console.error('推断语言失败:', error);
        return DEFAULT_LOCALE;
    }
}
